import React, { useEffect, useState, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useAppDispatch } from "../../../../store";
import { useSelector } from "react-redux";
import { RootState } from "../../../../reducer/index";
import {
  useNavigate,
	useSearchParams,
	useLocation,
  createSearchParams,
} from "react-router-dom";
import * as styles from "../../../../styles/WholedataPage";
import {
  LoadFarm,
  LoadDiaryList,
  TargetDiaryAct,
  GetWeather,
} from "../../../../reduxaction/post";
import { Farmstype } from "../../../../reducer/postpayloadtypes";

import userSlice from "../../../../reducer/user";
import "./component/DiaryDetailForm";
import DiaryDetailForm from "./component/DiaryDetailForm";
import axios from "axios";
import InsectName from "../component/InsectName";
import DiaryDetailEnvironment from "./component/DiaryDetailEnvironment";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import Modal from "../../../../components/Modal";
dayjs.locale("ko");

interface Props {
  sensors: Farmstype;
}

const DiaryDetail = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { TargetDiary, Farms, Targetfarms } = useSelector(
    (state: RootState) => state.post
  );
  const { me } = useSelector((state: RootState) => state.user);

  const [adjustmodal, setAdjustmodal] = useState<boolean>(false);

	const [deletemodal, setDeletemodal] = useState<boolean>(false);
	
  const location = useLocation();
	
	const [isArrow, setIsArrow] = useState<string>("");
  const [id1, setId1] = useState<string>("");
  const [id2, setId2] = useState<string>("");
  const [id3, setId3] = useState<string>("");
	const [id4, setId4] = useState<string>("");
	const [id5, setId5] = useState<string>("");
	const [id6, setId6] = useState<string>("");
	const [id7, setId7] = useState<string>("");
	const [backUrl, setBackUrl] = useState<string>("");
	
  const [serachparams] = useSearchParams();
  useEffect(() => {
    dispatch(TargetDiaryAct(serachparams.get("id")));
		dispatch(LoadFarm());
		setEnvData({ diaryId: Number(serachparams?.get("id")) });		
    dispatch(
      userSlice.actions.Routerpath(`/DiaryDetail?id=${serachparams.get("id")}`)
		);
		
		if (location.search || (location.state != null && location.state.isArrow)) { 
			
			let let_isArrow = location.state != null ? location.state.isArrow : location.search.split("&")[0].split("=")[1] ;
			let let_id1 = location.state != null ? location.state.id1 : location.search.split("&")[1].split("=")[1] ;
			let let_id2 = location.state != null ? location.state.id2 : location.search.split("&")[2].split("=")[1] ;
			let let_id3 = location.state != null ? location.state.id3 : location.search.split("&")[3].split("=")[1] ;
			let let_id4 = location.state != null ? location.state.id4 : location.search.split("&")[4].split("=")[1] ;
			let let_id5 = location.state != null ? location.state.id5 : location.search.split("&")[5].split("=")[1] ;
			let let_id6 = location.state != null ? location.state.id6 : location.search.split("&")[6].split("=")[1] ;
			let let_id7 = location.state != null ? location.state.id7 : location.search.split("&")[7].split("=")[1] ;
			let backUrl = location.state != null ? location.state.backUrl : location.search.split("&")[5].split("=")[1] ;

			if (let_isArrow !== "") setIsArrow(let_isArrow);
			if (let_id1 !== "") setId1(let_id1);
			if (let_id2 !== "") setId2(let_id2);
			if (let_id3 !== "") setId3(let_id3);
			if (let_id4 !== "") setId4(let_id4);
			if (let_id5 !== "") setId5(let_id5);
			if (let_id6 !== "") setId6(let_id6);
			if (let_id7 !== "") setId7(let_id7);
			if (backUrl !== "") setBackUrl(backUrl);
			
		}
  }, []);
  useEffect(() => {
    setMemo(TargetDiary?.note);
    setAge({
      diaryContentId: instar?.[0]?.diaryContentId,
      value: instar?.[0]?.value,
    });
    setPutdata(defalutdata);
		setGetImage(TargetDiary?.files);
		
    const Fday = dayjs(TargetDiary?.tagStdDate).format("YYYY-MM-DD");

    const Stime = dayjs(TargetDiary?.tagStdDate).format("HH:mm");

    let data = {};

    data = { ...data, startday: Fday };
    data = { ...data, time: Stime };

    setPostDate(data);
  }, [TargetDiary]);
  // 이미지
  let [getImage, setGetImage] = useState<any>(); // 받아온 이미지
  let [imageSrc, setImageSrc] = useState<any>([]); // 미리보기 이미지
  let [deleteImage, setDeleteImage] = useState<any>([]); // 삭제할 이미지
  let [uploadImage, setUploadImage] = useState<any>([]); // 새로 업로드하는 이미지
  // 질병 이미지
  // 발병이미지
  let [deleteOccurImage, setDeleteOccurImage] = useState<any>([]); // 삭제할 이미지
  let [uploadOccurImage, setUploadOccurImage] = useState<any>([]); // 새로 업로드하는 이미지
  // 곤충 폐사 이미지
  let [deleteDeathImage, setDeleteDeathImage] = useState<any>([]); // 삭제할 이미지
  let [uploadDeathImage, setUploadDeathImage] = useState<any>([]); // 새로 업로드하는 이미지

  const today = new Date();
  // 페이지에 표시되는 작업 일지 작성 시간
  const day = dayjs(TargetDiary?.tagStdDate).format(
    "YYYY년 MM월 DD일 dddd HH시 mm분"
  );
  // 작업 일지 작성시간 초기값
  let putdate = dayjs(TargetDiary?.tagStdDate).format("YYYY-MM-DD HH:mm");
  // 메모 등록
  let [memo, setMemo] = useState<String>();
  const AreaHandler = (e: any) => {
    setMemo(e.target.value);
  };
  //일지작성일,시간
  let [postdate, setPostDate] = useState<any>({
    time: "",
    startday: "",
  });
  const InputHandler = (e: any) => {
    setPostDate({ ...postdate, [e.target.name]: e.target.value });
  };
  //입력받은 날짜 데이터
  let timetest =
    postdate.time && postdate.startday
      ? postdate.startday + " " + postdate.time
      : null;
  //곤충령기
  let instar: any = TargetDiary?.diaryContents?.filter(
    (v: any) => v.diaryItem.name === "instar"
  ); // 초기 곤충 나이
  let [age, setAge] = useState({
    diaryContentId: null,
    value: null,
  }); // 곤충 나이
  const SelectHandler = (e: any) => {
    setAge({ ...age, value: e.target.value });
  };

  //작업 input 데이터
  let [putdata, setPutdata] = useState<any>([]);
  let defalutdata = TargetDiary?.diaryContents;
  // 기존에 필터링 하던 부분.(화면에 보여줄 항목 설정)
  // TargetDiary?.diaryContents.filter(
  //   (v: any) => v.diaryItem.view === "Y"
  // );

  let [bodydata, setBodydata] = useState<any>();

  const [envData, setEnvData] = useState({ diaryId: 0 });

  const plus = postdate.startday + " " + postdate.time;

  const selectDate = new Date(plus);


  let startdate; // 사육시작일
  let expdate; // 출하예정일

  //날짜 시간 셋팅
  TargetDiary?.diaryContents.map((item, idx) => {
    switch (item.diaryItem.name) {
      case "startFarmDate":
        startdate = item.value;
        break;
      case "expFarmDate":
        expdate = dayjs(item.value).format("YYYY년 MM월 DD일");
        break;
    }
	});
	
  //상자 가져오기
  const boxes = TargetDiary?.places.filter((box) => box.type === "BOX");

  //일지 삭제
  const DeleteSumit = () => {
    axios
      .delete(`/ifactory/api/diary/${serachparams.get("id")}`)
      .then((res) => {
        // alert("해당 일지가 삭제되었습니다.");
        confirmAlert({
          title: "삭제되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        navigate(-1);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // 일지 수정
  const PutSubmit = (bodydata: any) => {
    if (selectDate > new Date()) {
      // return alert("작성 시간이 현재 시간보다 앞설 수 없습니다.");
      return confirmAlert({
        title: "작성 시간이 현재 시간보다 앞설 수 없습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    let body = Object.keys(bodydata).map((key) => {
      return {
        diaryContentId: bodydata[key].diaryContentId,
        value: bodydata[key].value,
      };
    });
    body.push({
      diaryContentId: age.diaryContentId,
      value: age.value,
    });
    let tagStadDate = day.toLocaleString();
    if (timetest) {
      putdate = timetest;
    } else {
    }
    axios
      .put(`/ifactory/api/diary/${serachparams.get("id")}`, {
        tagStdDate: putdate,
        note: memo,
        diaryContents: body,
      })
      .then((res) => {
        if (TargetDiary?.diaryClass.name === "질병") {
          DiseaseImageUpload(TargetDiary?.diaryId);
        } else {
          ImageUpload(TargetDiary?.diaryId);
          ImageRemove();
        }
        confirmAlert({
          title: "수정되었습니다.",
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
        navigate("/MainPage", 
					{
						state: {
							isArrow: isArrow,
							id1: id1,
							id2: id2,
							id3: id3,
							id4: id4,
							id5: id5
						}
					})
      })
      .catch((error) => {
        console.error(error);

        confirmAlert({
          title: `${error.response.data.message}`,
          buttons: [
            {
              label: "Yes",
            },
          ],
        });
      });
  };

  const DiseaseImageUpload = (e: number) => {
    const OccurformData = new FormData();
    uploadOccurImage.map((item: any, idx: number) => {
      OccurformData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/pest/${e}`, OccurformData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // transformRequest: (formData) => formData,
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.error(error);
        console.log("이미지업로드실패");
      });

    const DeathformData = new FormData();
    uploadDeathImage.map((item: any, idx: number) => {
      DeathformData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/pestSample/${e}`, DeathformData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.error(error);
        console.log("이미지업로드실패");
      });

    DiseaseImageRemove();
  };

  const DiseaseImageRemove = () => {
    let datas: any = {
      fileNames: deleteOccurImage,
    };
    let datas2: any = {
      fileNames: deleteDeathImage,
    };

    axios.delete(`/ifactroy/api/file/deletefile`, {
      data: datas,
    });

    axios.delete(`/ifactroy/api/file/deletefile`, {
      data: datas2,
    });
  };

  const ImageUpload = (e: any) => {
    const formData = new FormData();
    uploadImage.map((item: any, idx: number) => {
      formData.append("image", item, item.name);
    });
    axios
      .post(`/ifactory/api/file/uploadfile/diary/${e}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        transformRequest: (formData) => formData,
      })
      .then((res) => {
        console.log("이미지업로드성공");
      })
      .catch((error) => {
        console.error(error);
        console.log("이미지업로드실패");
      });
  };

  const ImageRemove = () => {
    let datas: any = {
      fileNames: deleteImage,
    };

    axios.delete(`/ifactroy/api/file/deletefile`, {
      data: datas,
    });
  };

  const modalfunc = (type: string) => {
    if (type === "adjust") {
      setAdjustmodal(true);
    } else if (type === "delete") {
      setDeletemodal(true);
    }
  };

  const adjustpost = (type: string) => {
    if (type === "YES") {
      PutSubmit(bodydata);
    } else if (type === "NO") {
      setAdjustmodal(false);
    }
  };

  const deletepost = (type: string) => {
    if (type === "YES") {
      DeleteSumit();
    } else if (type === "NO") {
      setDeletemodal(false);
    }
  };

  const feeddayfunc = (feedday: any) => {
    if (feedday === "Invalid Date") {
      return "날짜가 없습니다.";
    } else {
      return dayjs(feedday).format("YYYY년 MM월 DD일");
    }
  };

  return (
    <styles.Container>
      <styles.PageTop>
        <p className="move-btn">
          <img
            src="./img/ArrowLeft.svg"
            onClick={() => {
							//navigate(-1);
							navigate("/"+backUrl, {
								state: {
									isArrow: isArrow,
									id1: id1,
									id2: id2,
									id3: id3,
									id4: id4,
									id5: id5,
									id6: id6,
									id7: id7
								}
							});
            }}
          />
        </p>
				<p className="pagetit">사육일지 수정</p>
        {TargetDiary?.regId === me?.userId && (
          <p className="btn-box">
            <button className="submit" onClick={() => modalfunc("adjust")}>
              수정
            </button>
            <button className="submit" onClick={() => modalfunc("delete")}>
              삭제
            </button>
          </p>
        )}
      </styles.PageTop>
      <styles.InfoData>
        <p className="Date">
          작업시간: &nbsp;
          {day}
        </p>
        <styles.InfoBox>
          <styles.InfoItem>
            <p>곤충명</p>
            <p>
              <span className="insect-name">
                {TargetDiary
                  ? InsectName(TargetDiary?.diaryClass?.productCode)
                  : null}
              </span>
            </p>
          </styles.InfoItem>
          <styles.InfoItem>
            <p>사육시작</p>
            {feeddayfunc(TargetDiary?.startFarmDate)}
          </styles.InfoItem>
          <styles.InfoItem>
            <p className="c-22c197">출하예정일</p>
            <p className="c-22c197">{feeddayfunc(TargetDiary?.expFarmDate)}</p>
          </styles.InfoItem>
          <styles.InfoItem>
            <p>작성자</p>
            <p className="Spoqa700">{TargetDiary?.worker}</p>
          </styles.InfoItem>
        </styles.InfoBox>
      </styles.InfoData>

      <styles.BreedingBox>
        <styles.BreedingBoxTop>
          <p className="content-tit">사육상자</p>
          <p key={"boxCnt"}>(1개 선택)</p>
        </styles.BreedingBoxTop>
        <styles.BreedingBoxBot style={{ paddingLeft: '38px', paddingBottom: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
          {boxes?.map((box) => {
            let instarcolor = "";

            switch (TargetDiary?.instar) {
              // case "EGG":
              //   instarcolor = "#feca0a";
              //   break;
              // case "IMAGO":
              //   instarcolor = "#b96730";
              //   break;
              // case "PUPA":
              //   instarcolor = "#afaad3";
              //   break;
              // case "LARVA":
              //   instarcolor = "#8bc63e";
              //   break;
              default:
                instarcolor = "#2a3a4b";
            }

            return (
              <p
                className={"breedingbox-active"}
                style={{ background: instarcolor, color: "white", display: 'inline-block' }}
              >
                {box.name}
              </p>
            );
          })}
        </styles.BreedingBoxBot>
      </styles.BreedingBox>

      {/* 환경정보 컴포넌트 */}
      <DiaryDetailEnvironment data={serachparams.get("id")} />

      <DiaryDetailForm
        memo={memo}
        postdate={postdate}
        AreaHandler={AreaHandler}
        InputHandler={InputHandler}
        SelectHandler={SelectHandler}
        setPutdata={setPutdata} // 입력받을 데이터
        setBodydata={setBodydata}
        putdata={putdata}
        age={age}
        imageSrc={imageSrc}
        setImageSrc={setImageSrc}
        getImage={getImage}
        setGetImage={setGetImage}
        uploadImage={uploadImage}
        setUploadImage={setUploadImage}
        deleteImage={deleteImage}
        setDeleteImage={setDeleteImage}
        // 질병 이미지 관련
        deleteOccurImage={deleteOccurImage}
        setDeleteOccurImage={setDeleteOccurImage}
        uploadOccurImage={uploadOccurImage}
        setUploadOccurImage={setUploadOccurImage}
        deleteDeathImage={deleteDeathImage}
        setDeleteDeathImage={setDeleteDeathImage}
        uploadDeathImage={uploadDeathImage}
        setUploadDeathImage={setUploadDeathImage}
      />

      {adjustmodal && (
        <Modal
          title={"수정하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => adjustpost("YES")}
          secondclick={() => adjustpost("NO")}
        />
      )}

      {deletemodal && (
        <Modal
          title={"삭제하시겠습니까?"}
          first={"예"}
          second={"아니오"}
          firstclick={() => deletepost("YES")}
          secondclick={() => deletepost("NO")}
        />
      )}
    </styles.Container>
  );
};

export default DiaryDetail;
